import { render, staticRenderFns } from "./SubHeader.vue?vue&type=template&id=f5c34e6e&scoped=true&"
import script from "./SubHeader.vue?vue&type=script&lang=ts&"
export * from "./SubHeader.vue?vue&type=script&lang=ts&"
import style0 from "./SubHeader.vue?vue&type=style&index=0&id=f5c34e6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c34e6e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer,VImg,VRow})
